var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content__inner referrer-page"},[_c('h1',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.logoLink}},[_c('img',{attrs:{"src":_vm.logo}})])],1),_c('div',{staticClass:"description"},[_c('img',{attrs:{"src":_vm.referrerText}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }